import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Fragment } from "react/jsx-runtime";

const SummarySkeleton = () => {
  return (
    <Card>
      <CardContent className="flex flex-col gap-4 pt-6 xl:flex-row xl:items-start">
        <div className="grid grow grid-cols-6 gap-4">
          {Array.from({ length: 3 }).map((_, index) => (
            <Fragment key={index}>
              <Skeleton className="col-span-4" style={{ height: "40px" }} />
              <Skeleton className="col-span-2" style={{ height: "40px" }} />
            </Fragment>
          ))}
        </div>

        <div className="flex flex-col items-center p-20 xl:self-center xl:py-0">
          <Skeleton
            className="rounded-full"
            style={{ width: "140px", height: "140px" }}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SummarySkeleton;
